export enum AdminPermissionTypes {
    AppearInTicketingDropdown = 1,
    ReceivesWeeklySync = 2,
    IsTrainer = 3
}

export class AdminPermissionItem {
    ID: number;
    AdminID: number;
    PermissionType: AdminPermissionTypes;
    DateTimeCreated: Date;
}

export class AdminPermissionItemArray extends Array<AdminPermissionItem> {

    constructor(...items: AdminPermissionItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdminPermissionItemArray.prototype);
    }
}
